import { render, staticRenderFns } from "./LiveCamera.vue?vue&type=template&id=97ccdf32"
import script from "./LiveCamera.vue?vue&type=script&lang=js"
export * from "./LiveCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports